import * as yup from 'yup';

const voucherValidation = yup.object().shape({
  code: yup.string().required('Code is required.').max(255, 'Code must be less than 255 characters.'),
  name: yup.string().required('Name is required.').max(255, 'Name must be less than 255 characters.'),
  description: yup.string().required('Description is required.').max(2000, 'Description must be less than 2000 characters.'),
  max_uses: yup.number()
    .typeError('Max uses must be an integer.')
    .integer('Max uses must be an integer.')
    .required('Max uses is required')
    .min(1, 'Max uses must be at least 1.'),
  max_uses_user: yup.number()
    .typeError('Max uses per user must be an integer.')
    .integer('Max uses per user must be an integer.')
    .required('Max uses per user is required')
    .min(1, 'Max uses per user must be at least 1.'),
  discount_amount: yup.number()
    .typeError('Discount amount must be a number.')
    .required('Discount amount is required')
    .min(1, 'Discount amount must be at least 1.'),
  active: yup.bool(),
  is_fixed: yup.bool(),
  auto_apply: yup.bool(),
  starts_at: yup.date().required('Start date is required.'),
  expires_at: yup.date().required('Expiration date is required.'),
});

export default voucherValidation;
